module.exports = __webpack_public_path__ + "img/wrapbg6.11550b87.png";